import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import moment from 'moment';
import { CurrentUser } from '../model/CurrentUser';

@Injectable({
  providedIn: 'root'
})
export class ReferrerAuthenticationService {

  currentUserSubject: any;
  currentUser: any;

  constructor(
    private http: HttpClient,
  ) {
  }

  getCurrentUser(): any {
    return JSON.parse(localStorage.getItem('storedReferrerUser'));
  }

  logout() {
    // logout of the current patient
  }

  storeReferrerToken(token) {

    if ((token.access_token != '') && (token.access_token != null)) {
      localStorage.setItem("TDOReferrerAuthToken", token.access_token);
      //console.log('tok:' + authresult.access_token);
      const expiresAt = moment().add(token.expiresIn, 'second');
      var currentUser: CurrentUser = new CurrentUser();
      currentUser.webclientid = token.webclientid;
      currentUser.TDOCID = token.TDOCID;
      currentUser.authdata = token;
      currentUser.callingapp = 'TDOx';
      currentUser.firstname = '';
      currentUser.lastname = ''
      currentUser.nickname = token.usernickname;

      currentUser.fullname = token.userfullname;
      currentUser.TDOGuid = token.TDOGuid;

      currentUser.userdisplayname = token.userdisplayname;
      currentUser.userroles = token.userroles;
      currentUser.authtoken = token.access_token;
      currentUser.expires_at = JSON.stringify(expiresAt.valueOf());

      localStorage.setItem("storedReferrerUser", JSON.stringify(currentUser));


      return true;
    }
    else
    {
      return false;
    }

  }

}
